import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BackendService } from './backend.service';

export interface Suggestion {
  label: string;
  prompt: string;
  agent_id: string;
}

@Injectable({ providedIn: 'root' })
export class SuggestionService {
  constructor(
    private readonly http: HttpClient,
    private readonly backend: BackendService,
  ) {}

  getSuggestions(): Observable<Suggestion[]> {
    const url = this.backend.createAgentsUrl('agenthome/registry/suggestions');
    // REST router wraps responses in {success, message, body}.
    return this.http
      .get<{ success: boolean; message: string; body: { suggestions: Suggestion[] } | null }>(url)
      .pipe(
        map(res => res?.body?.suggestions ?? []),
        catchError(() => of([])),
      );
  }
}
